import { Grid, Button } from "@mui/material";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../redux";
import { cleanUnderReviewAction, setAuditComment, setAuditDecision, setAuditReason } from "./QueueSlice";
import { CustomModal } from "../CompletionPage/CustomModal";
import { Statuses } from "../../constants";

export function Controls() {
  const dispatch = useAppDispatch();
  const [modal, setModal] = useState<boolean>(false);
  const [modalType, setModalType] = useState<string | null>(null);
  useEffect(() => {
    if (!modal) {
      dispatch(setAuditDecision(null));
      dispatch(setAuditComment(""));
      dispatch(setAuditReason(null));
      setAuditReason(null);
    }
  }, [modal]);

  const restartQueue = async () => {
    await dispatch(cleanUnderReviewAction());
  };

  return (
    <Grid container spacing={3} sx={{ marginTop: 5 }}>
      <CustomModal modal={modal} handleClose={() => setModal(false)} type={modalType} />

      <Grid item xs={12} xl={12}>
        <Button
          sx={{ backgroundColor: "green", width: "100%" }}
          variant="contained"
          onClick={() => {
            dispatch(setAuditDecision(Statuses.approved));
            setModalType("decision");
            setModal(true);
          }}
        >
          Approve
        </Button>
      </Grid>
      <Grid item xs={12} xl={12}>
        <Button
          onClick={() => {
            setModalType("decision");
            setModal(true);
            dispatch(setAuditDecision(Statuses.A2Review));
          }}
          sx={{ backgroundColor: "red", width: "100%" }}
          variant="contained"
        >
          For A2 review
        </Button>
      </Grid>

      <Grid item xs={12} xl={12}>
        <Button
          onClick={() => {
            setModalType("skip_case");
            setModal(true);
          }}
          sx={{ width: "100%" }}
          variant="contained"
        >
          Next Case
        </Button>
      </Grid>
      <Grid sx={{ marginBottom: 0 }} item xs={12} xl={12}>
        <Button onClick={() => restartQueue()} sx={{ width: "100%" }} variant="contained">
          Restart Queue
        </Button>
      </Grid>
    </Grid>
  );
}
